let initialVersion: string | null = null;

export async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.version ?? null;
  } catch {
    return null;
  }
}

export function initVersionCheck() {
  fetchVersion().then((v) => {
    if (v) initialVersion = v;
  });
}

export function getInitialVersion() {
  return initialVersion;
}
